<template>
  <div class="app-page">
    <PageHeader />
    <div class="application-page-container">
      <section>
        <div class="btn-action-group">
          <router-link :to="{ path: `/master/permission/employee_detail/new` }">
            <a-button type="primary">
              <PlusOutlined />
              {{ $t('admin.Add New Employee') }}
            </a-button>
          </router-link>
          &nbsp;&nbsp;
          <a-button @click="downloadVisible = true">
            {{ $t('admin.Download Employee Application Records') }}
          </a-button>
        </div>
        <a-input-search
          clss="input-search-panel"
          v-model:value="keyword"
          allow-clear
          :placeholder="$t('admin.Employee / Review Manager')"
          :loading="loading"
          @search="onSearch"
        />
      </section>
      <section class="application-counter">
        <div class="counter-text">
          <span>
            {{ $t('admin.Total') }}: {{ pagination.total }}
            {{
              pagination.total > 1
                ? $t('admin.Employees')
                : $t('admin.Employee')
            }}
          </span>
        </div>
        <div class="page-pagination">
          <a-pagination
            @change="fetchData"
            v-model:current="pagination.current"
            :total="pagination.total"
            v-model:pageSize="pagination.pageSize"
            :pageSizeOptions="pagination.pageSizeOptions"
            size="small"
            show-less-items
            show-size-changer
            show-quick-jumper
          />
        </div>
      </section>
      <a-table
        class="job-table"
        :rowKey="(record) => `${record.id}-${record.apply_id}`"
        :columns="columns"
        :data-source="dataSource"
        @change="onChange"
        :pagination="false"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>
        <template v-slot:headerCell="{ title, column }">
        {{ $t('admin.' + title) }}
        </template>

        <template v-slot:bodyCell="{ record, column }">
          <template v-if="column.key === 'lion_id'">
            <span
              :class="{ highlight: record.lion_id.trim() == keyword.trim() }"
            >
              {{ record.lion_id }}
            </span>
          </template>
          <template v-if="column.key === 'name'">
            <span :class="{ highlight: record.name.trim() == keyword.trim() }">
              {{ record.name }}
            </span>
          </template>
          <template v-if="column.key === 'lm_name'">
            <span
              :class="{ highlight: record.lm_name.trim() == keyword.trim() }"
            >
              {{ record.lm_name }}
            </span>
          </template>
          <template v-if="column.key === 'status'">
            <ApplyStatusColumn :data="record" />
          </template>
          <template v-else-if="column.key === 'action'">
            <router-link
              :to="{ path: `/master/permission/employee_detail/${record.id}` }"
            >
              <a-button block type="link" :disabled="!record.in_scope">
                {{ $t('admin.Edit') }}
              </a-button>
            </router-link>
            <router-link
              :to="{ path: `/master/permission/employee_change/${record.id}` }"
            >
              <a-button block type="link" :disabled="!record.in_scope">
                {{ $t('admin.Change') }}
              </a-button>
            </router-link>

            <a-button block type="link" @click="dualRole(record)">
              {{ $t('admin.Dual Role') }}
            </a-button>

            <a-button block type="link" @click="disableAccount(record)">
              {{ $t('admin.Cancel Account') }}
            </a-button>
          </template>
        </template>
      </a-table>
      <div class="table-pagination">
        <div></div>
        <a-pagination
          @change="fetchData"
          v-model:current="pagination.current"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          size="small"
          show-less-items
          show-size-changer
          show-quick-jumper
        />
      </div>
    </div>
    <a-modal
      v-model:visible="downloadVisible"
      centered
      :title="$t('admin.Download employee application record')"
      :maskClosable="false"
      width="480px"
      :footer="null"
    >
      <div class="download-promotion-record-buttons">
        <a-button
          class="download-promotion-record-button"
          @click="downloadLatestPromotionRecord"
        >
          {{ $t('admin.Download Current Record') }}
        </a-button>
        <a-button
          class="download-promotion-record-button"
          @click="downloadAllPromotionRecord"
        >
          {{ $t('admin.Download all Record') }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PageHeader from '../components/PageHeader.vue'
  import { PlusOutlined } from '@ant-design/icons-vue'
  import { message, Modal } from 'ant-design-vue'
  import {
    getEmployeePermissionList,
    disableEmployeeAccount,
    addManagerIdentityRightsForEmployee,
  } from '@/api/admin'
  import { promotionRecordsExportAdmin } from '@/api/index'
  import {
    // ApplyStatusHeader,
    ApplyStatusColumn,
  } from '@/components/ApplyStatus/index.js'
  import Empty from '@/components/Empty'

  export default {
    name: 'Index',
    components: {
      PlusOutlined,
      PageHeader,
      // ApplyStatusHeader,
      ApplyStatusColumn,
      Empty,
    },
    data() {
      return {
        loading: false,
        uploadDataUrl: '/api/RoleC/Import',
        keyword: '',
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '30', '50'],
        },
        dataSource: [],
        renameVisible: false,
        downloadVisible: false,
        fileTemplate: {},
      }
    },
    computed: {
      columns() {
        return [
          {
            title: 'Lion ID',
            key: 'lion_id',
            dataIndex: 'lion_id',
          },
          {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
          },
          {
            title: 'Current Brand',
            key: 'brand',
            dataIndex: 'brand',
          },
          {
            title: 'Title',
            key: 'title',
            dataIndex: 'title',
          },
          {
            title: 'Location',
            key: 'location',
            dataIndex: 'location',
          },
          {
            title: 'Review Manager',
            key: 'lm_name',
            dataIndex: 'lm_name',
          },
          {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
          },
          {
            title: 'Action',
            key: 'action',
            width: 150,
          },
        ]
      },
      ...mapGetters({
        ability: 'acl/ability',
        Authorization: 'user/accessToken',
      }),
      canCancel() {
        const ability = this.ability.find(
          (item) => item.key === 'can_cancel_account'
        )
        return ability.value
      },
      canReopen() {
        const ability = this.ability.find((item) => item.key === 'can_reopen')
        return ability.value
      },
    },
    created() {
      this.fetchData()
    },
    methods: {
      fetchData() {
        const params = {
          pageSize: this.pagination.pageSize || 10,
          pageNum: this.pagination.current || 1,
          keywords: this.keyword,
        }
        this.loading = true
        getEmployeePermissionList(params)
          .then((res) => {
            if (res.code === 200) {
              this.dataSource = res.data
              this.pagination.total = res.page.total
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      downloadLatestPromotionRecord() {
        promotionRecordsExportAdmin(this.Authorization, { latest: 1 }).then(
          (msg) => {
            const fileDesc = msg.headers['content-disposition']
            const fileName = fileDesc.substr(fileDesc.indexOf('filename') + 10)
            const file = new Blob([msg.data])
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = (e) => {
              var link = document.createElement('a')
              link.style.display = 'none'
              link.href = e.target.result
              link.download = fileName

              var body = document.querySelector('body')
              body.appendChild(link)
              link.click()
              body.removeChild(link)
              window.URL.revokeObjectURL(link.href)
            }
          }
        )
      },
      downloadAllPromotionRecord() {
        promotionRecordsExportAdmin(this.Authorization).then((msg) => {
          const fileDesc = msg.headers['content-disposition']
          const fileName = fileDesc.substr(fileDesc.indexOf('filename') + 10)
          const file = new Blob([msg.data])
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = (e) => {
            var link = document.createElement('a')
            link.style.display = 'none'
            link.href = e.target.result
            link.download = fileName

            var body = document.querySelector('body')
            body.appendChild(link)
            link.click()
            body.removeChild(link)
            window.URL.revokeObjectURL(link.href)
          }
        })
      },
      onSearch() {
        this.pagination.current = 1
        return this.fetchData()
      },
      onChange() {
        return this.fetchData()
      },
      dualRole(record) {
        const that = this
        Modal.confirm({
          title: this.$t('admin.Dual Role'),
          okText: this.$t('admin.Dual'),
          cancelText: this.$t('admin.Cancel'),
          closable: true,
          content: this.$t(
            'admin.Are you sure to add manager identity rights for this employee?'
          ),
          async onOk() {
            try {
              await addManagerIdentityRightsForEmployee(record.id)
              message.success(
                that.$t(
                  'admin.You have successfully added manager privileges for this employee'
                )
              )
            } catch (e) {
              message.error(e.msg)
            }
          },
        })
      },
      disableAccount(record) {
        let that = this
        Modal.confirm({
          title: this.$t('admin.Cancel Account'),
          okText: this.$t('admin.Yes'),
          cancelText: this.$t('admin.No'),
          closable: true,
          content: this.$t(
            'admin.Are you sure you want to cancel the current account?'
          ),
          onOk() {
            return disableEmployeeAccount(record.id).then((res) => {
              if (res.code === 200) {
                record.is_block = true
                that.fetchData()
              } else {
                message.info(res.msg)
              }
            })
          },
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');

  .application-page-container {
    margin: @app-conetent-margin;
    background-color: white;
    padding: 24px;

    section {
      display: flex;
      justify-content: space-between;
    }

    .input-search-panel {
      width: 285px;
    }

    .application-counter {
      padding: 24px 0;
      align-items: center;

      .counter-text {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;

        span {
          margin-right: 12px;
        }
      }
    }
  }

  .btn-groups {
    .ant-btn {
      display: block;
    }
  }

  .table-pagination {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .form-field-title {
    font-size: 14px;
    font-family: Helvetica;
    color: #333333;
    line-height: 22px;
    margin: 8px 0;
  }

  :deep {
    .table-pagination,
    .page-pagination {
      .ant-pagination-item-active {
        a {
          color: white;
        }

        background-color: @primary-color;
      }
    }
  }

  .download-promotion-record-buttons {
    display: flex;
    justify-content: space-between;
  }

  span.highlight {
    color: @primary-color;
    font-weight: bold;
  }
</style>
